






















import {Component, Prop, Vue} from 'vue-property-decorator';
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"
import {ActiveProvide} from "@/support/reactive"

/**
 * @status stable
 * @published 2.0.0
 * @changelog 2.0.0 Published.
 * @changelog 4.2.2 Add icon prop, add green color, remove first and last props.
 */
@Component({
    components: {JdsGlyph, JdsIcon}
})
export default class JdsTimelineItem extends Vue {
    @Prop({default: false, type: Boolean}) big!: boolean
    @Prop({default: 'grey', type: String}) color!: 'purple' | 'blue' | 'grey' | 'fuchsia' | 'green'

    /**
     * Use an icon for grammar-approved common states. Prefer mini icons when possible, as these will be shown in
     * 10px contexts.
     */
    @Prop() icon!: string

    @ActiveProvide('jds.button.type') buttonType = 'tertiary'
    @ActiveProvide('jds.button.size') buttonSize = 'tight'
    @ActiveProvide('jds.button.borderless') buttonBorderless = true

    get size() {
        if (this.icon) return 16
        if (this.big) return 10
        return 6
    }

    get pointClass() {
        return [this.color]
    }

    get pointStyle() {
        return {
            top: "calc(1.2em - " + (this.size / 2) + "px",
            left: ((-this.size / 2) + 1) + "px",
            width: this.size + "px",
            height: this.size + "px",
        }
    }

}
